export default __webpack_public_path__ + "static/videoarrow-093f31d5ab5c036df14bad69d117d270.svg";